import * as React from 'react';
import { Stepper, Step, Tooltip } from '@mui/material';
import { CustomStepConnector } from '@styles/mui-steps/stepper-conector';
import { CustomStepLabel } from '@styles/mui-steps/stepper-label';

const StepperSolicitacao = ({ activeStep, steps, isFluxoConcluido = false }) => {
    console.log(activeStep)
    return (
        <div>
            <Stepper
                alternativeLabel
                activeStep={activeStep}
                connector={<CustomStepConnector />}
            >
                {steps.map((step, index) => {
                    const isCompleted = isFluxoConcluido
                        ? index <= activeStep
                        : index < activeStep;

                    return (
                        <Step key={index} completed={isCompleted}>
                            <Tooltip title={step.description} arrow placement="bottom">
                                <div>
                                    <CustomStepLabel icon={step.displayValue}>
                                        {step.label}
                                    </CustomStepLabel>
                                </div>
                            </Tooltip>
                        </Step>
                    );
                })}
            </Stepper>
        </div>
    );
};

export default StepperSolicitacao;
